import React, { PureComponent } from 'react'
import { string, func, bool } from 'prop-types'
import classNames from 'classnames'
import Button from '@active/react-ui/Button'
import I18nMessage from '../I18nMessage'
import './SSOContent.scss'

const PAGE_RENDER = 'PAGE_RENDER'
const BUTTON_TEXT_CONFIG = {
  IDP_SPARTAN: 'passport.common.text.signWithSpartan',
  IDP_IRONMAN: 'passport.common.text.signWithIronman',
  IDP_TIMETO: 'passport.common.text.signWithTimeTo',
}

class SSOContent extends PureComponent {
  static propTypes = {
    renderModel: string,
    name: string,
    onIdpSignin: func.isRequired,
    loginUrl: string,
    keycloakAPIServerHost: string,
    isPageModel: bool,
  }

  static defaultProps = {
    renderModel: '',
    name: '',
    loginUrl: '',
    keycloakAPIServerHost: '',
    isPageModel: false,
  }

  handleClick = clickEvent => {
    const {
      loginUrl, keycloakAPIServerHost, onIdpSignin, name, isPageModel,
    } = this.props
    if (isPageModel) {
      const keycloakOrigin = new URL(keycloakAPIServerHost).origin
      window.location.href = `${keycloakOrigin}${loginUrl}`
      return false
    }

    return onIdpSignin({ clickEvent, name })
  }

  render() {
    const { renderModel, name } = this.props
    const buttonText = BUTTON_TEXT_CONFIG[name]
    const isPageModel = renderModel === PAGE_RENDER

    return (
      <section>
        <div className={`${isPageModel ? 'sso-card' : ''}`}>
          <section className={classNames('sso-option-view', `sso-option-${name}`)}>
            {isPageModel && <div className="sso-option-view__header" />}
            <div className={`sso-option-view__title${!isPageModel ? ' sso-option-view__title--alignLeft' : ''}`}>
              <I18nMessage id="passport.signin.title" />
            </div>
            <div className="sso-option-view__button-container">
              <Button type="super" onClick={this.handleClick}>
                <i className="button-icon" />
                <span className="button-text">
                  <I18nMessage id={buttonText || 'passport.common.text.signWithActivePassport'} />
                </span>
              </Button>
            </div>
          </section>
        </div>
      </section>
    )
  }
}

export default SSOContent
